import type { EnumUnion } from '@dresscode-frontend/utility-types';
import type { DevDocumentKind, DevDocumentListItem, DevDocumentStatus } from '@/features/stacktrace/dev-documents/-query/type';

/**
 * プロダクト詳細 > 開発ドキュメントタブ のテーブル列 ID。
 *
 * 表示項目:
 *   コード / タイトル / 種別 / ステータス / 更新日
 *
 * 台帳の一覧画面（`/development-documents`）と違い「プロダクト」列は持たない。
 * 対象プロダクトは画面（URL の `$id`）で固定されているため、全行同じ値になる。
 */
export const ProductDevDocumentTableColumns = {
  CODE: 'CODE',
  TITLE: 'TITLE',
  KIND: 'KIND',
  STATUS: 'STATUS',
  UPDATED_AT: 'UPDATED_AT'
} as const;
export type ProductDevDocumentTableColumns = EnumUnion<typeof ProductDevDocumentTableColumns>;
type ProductDevDocumentCodeColumn = {
  id: string;
  code: string;
};
export type ProductDevDocumentTableRowData = {
  [ProductDevDocumentTableColumns.CODE]: ProductDevDocumentCodeColumn;
  [ProductDevDocumentTableColumns.TITLE]: string;
  [ProductDevDocumentTableColumns.KIND]: DevDocumentKind | undefined;
  [ProductDevDocumentTableColumns.STATUS]: DevDocumentStatus | undefined;
  [ProductDevDocumentTableColumns.UPDATED_AT]: string | null;
};
export const convertProductDevDocumentItemToTableRow = (item: DevDocumentListItem): ProductDevDocumentTableRowData => ({
  [ProductDevDocumentTableColumns.CODE]: {
    id: item.id,
    code: item.code
  },
  [ProductDevDocumentTableColumns.TITLE]: item.title,
  [ProductDevDocumentTableColumns.KIND]: item.kind as DevDocumentKind | undefined,
  [ProductDevDocumentTableColumns.STATUS]: item.status as DevDocumentStatus | undefined,
  // 台帳側の更新日時。`sourceUpdatedAt`（源泉ファイルの更新日）は棚卸しで
  // 取り込んだ行にしか入らないため、一覧では使わない。
  [ProductDevDocumentTableColumns.UPDATED_AT]: item.updatedAt
});